module.exports = __webpack_public_path__ + "static/media/seo_icon.3c472297.svg";